var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-nav"},[_c('div',{staticClass:"nav-wrap"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/index/small_logo.svg"),"alt":""}})]),_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/back.svg"),"alt":""}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }